// NOTE:
// for SSL mode, see `postgre-consts`, as the properties & enums are identical

import { ISelectOption, Type } from 'shell-models-lib';


export type GreenplumAdditionalPropertiesKeyType =
    | 'commandTimeout'
    | 'connectionTimeout';

export const greenplumAdditionalFieldsKeyOptions: Array<ISelectOption<GreenplumAdditionalPropertiesKeyType>> = [
    {
        label: 'Connection timeout',
        value: 'connectionTimeout',
        type: Type.Int
    },
    {
        label: 'Command timeout',
        value: 'commandTimeout',
        type: Type.Int
    }
];

export const greenplumAdditionalFieldsAllowedKeys: GreenplumAdditionalPropertiesKeyType[] = greenplumAdditionalFieldsKeyOptions.map((option) => option.value);